const alphanumericRegex = /^[a-zA-Z0-9]*$/;

const isAlphanumeric = (input: string): boolean => alphanumericRegex.test(input);

export default isAlphanumeric;
